export const habitatInsightsLandCoverTypes = [
    'Water',
    'Grass',
    'Trees',
    'Flooded Vegetation',
    'Crops',
    'Shrub and Scrub',
    'Built',
    'Bare',
    'Snow and Ice',
];

export const habitatInsightsConnectivityTypes = [
    'Grass',
    'Grass - Annual Variability',
    'Trees',
    'Trees - Annual Variability',
    'All Green',
    'All Green - Annual Variability',
];

export const habitatInsightsPrimaryProductivityTypes = ['Annual Average', 'Annual Average - Annual Range'];

// Habitat map sidebar copy for when there is no chart to draw. Hardcoded rather than
// CMS-managed: kept together so moving to the CMS slug pattern stays a contained change.
export const habitatMapSidebarStateMessages = {
    NoData: 'No habitat data is available for this polygon in the selected period.',
    Processing: 'This imagery is still being generated. Please check back shortly.',
    // Shown to internal users only. External users get Unavailable instead: telling a customer
    // there is no data would be untrue when the data exists and we failed to produce it.
    Error: 'We could not load habitat data for this polygon. Please try again shortly.',
    Unavailable: 'This data is not available at the moment.',
    NoSelection: 'Select one or more polygons to see their habitat data.',
} as const;

export type HabitatMapSidebarState = keyof typeof habitatMapSidebarStateMessages;

// Shown with the failure block so staff are not left thinking a customer is seeing it too.
export const habitatMapSidebarInternalOnlyNote = 'Internal only — not shown to customers';

export const habitatInsightsMetricExplainerSlugs: { [key: string]: { defaultSlug: string; explainerSlug: string } } = {
    Land_Cover: { defaultSlug: 'land-cover', explainerSlug: 'land-cover-te' },
    Habitat_Connectivity: { defaultSlug: 'habitat-connectivity', explainerSlug: 'habitat-connectivity-te' },
    Primary_Productivity: { defaultSlug: 'portfolio-vegetation-health', explainerSlug: 'portfolio-vegetation-health-te' },
    BiodiversityIntactnessIndex: { defaultSlug: 'BiodiversityIntactnessIndex', explainerSlug: 'BiodiversityIntactnessIndex-te' },
    HumanModificationIndex: { defaultSlug: 'HumanModificationIndex', explainerSlug: 'HumanModificationIndex-te' },
    Vegetation_Condition: { defaultSlug: 'portfolio-vegetation-health', explainerSlug: 'portfolio-vegetation-health-te' },
    All_Connectivity: { defaultSlug: 'habitat-connectivity', explainerSlug: 'habitat-connectivity-te' },
};
